<template>
	<main class="app-main">
		<router-view />
		<div class="hidden-btns">
			<button class="reload-btn" type="button" @dblclick="reload()"></button>
		</div>
	</main>
	<app-icons />
	<app-messages />
	<inactivity-screensaver />
	<install-prompt />
	<refresh-service-worker />
</template>

<script setup>
import { useStore } from '@/store';
import AppIcons from '@/views/_partials/AppIcons.vue';
import { watch } from 'vue';
import { useI18n } from 'vue-i18n';
import AppMessages from './views/_partials/AppMessages.vue';
import InactivityScreensaver from './views/_partials/InactivityScreensaver.vue';

const store = useStore();
const { locale } = useI18n();

watch(locale, value => document.documentElement.lang = value, { immediate: true });

function reload() {
	window.location.reload()
}

// Right click block
const handleContextMenu = e => e.preventDefault();
const startRightClickBlock = () => document.addEventListener('contextmenu', handleContextMenu);
const stopRightClickBlock = () => document.removeEventListener('contextmenu', handleContextMenu);

// User select block
const updateUserSelect = value => document.documentElement.style.setProperty('--user-select', value ? 'none' : 'auto');

// Watch settings
watch(() => store.settings.disableRightClick, x => x ? startRightClickBlock() : stopRightClickBlock(), { immediate: true });
watch(() => store.settings.disableUserSelect, updateUserSelect, { immediate: true });
</script>

<style>
:root {
	--user-select: auto;
}

body {
	user-select: var(--user-select);
	-webkit-user-select: var(--user-select);
}
</style>
